import React from 'react';
import { useSelector } from 'react-redux';
import { get } from 'lodash';
import { ViewerSessionsDropmenu } from '@components/viewer-sessions';
import { VMTitle } from './styled';
import viewerSessionsSelector from '@store/viewerSessions/selectors';
import { CONST_STATE } from '@store/viewerSessions/reducer';
import commonSelector from '@store/common/selectors';
import featureNames from '@utils/featureToggle/constants';
import ExportTable from './ExportTable';
import moment from 'moment';
import { VM_TIME_LIMIT } from '@components/viewer-sessions/table/Limit';

// migrated from old dimenesion container
// TODO: cleanup
function ViewerHeader({ interval }) {
  const viewerDrillDownKey = 'trends';

  const customerAccountType = get(useSelector(commonSelector), [
    'features',
    featureNames.CUSTOMER_ACCOUNT_TYPE,
  ]);

  const { selectedMetrics, anchoredMetrics, exceedTimeLimit } = get(
    useSelector(viewerSessionsSelector),
    [viewerDrillDownKey],
    CONST_STATE,
  );

    // TODO: consume from selector or move limit to atomic state
    const withinTimeLimit =
    moment(interval.to).diff(moment(interval.from), 'minutes') <= VM_TIME_LIMIT * 60;

  return (
    <VMTitle>
      <div style={{ flex: 1 }}>{`Subset of Viewer Sessions (up to 1500)`}</div>
      {withinTimeLimit && (
        <ExportTable />
      )}
      <ViewerSessionsDropmenu
        selectedMetrics={selectedMetrics}
        anchoredMetrics={anchoredMetrics}
        exceedTimeLimit={exceedTimeLimit}
        viewerDrillDownKey={viewerDrillDownKey}
        customerAccountType={customerAccountType}
      />
    </VMTitle>
  );
}

export default ViewerHeader;
